import {
  required,
  Create,
  SimpleForm,
  FileInput,
  FileField,
  useRedirect
} from "react-admin";
import { CustomToolbar } from "../../../utils";

const validateRequired = required();

export const KitImport = (props) => {
  const redirect = useRedirect();

  const handleSuccess = () => {
    redirect("/kits");
  };
  return (
    <Create title="Importar kit"  mutationOptions={{ onSuccess: () => handleSuccess() }} {...props}>
      <SimpleForm redirect="false" toolbar={<CustomToolbar />}>
        <div className="create-import-container">

          <FileInput
            source="csv"
            label="Lista de kits"
            accept=".csv"
            validate={validateRequired}
            className="file-input-full-width"
          >
            <FileField source="src" title="title" />
          </FileInput>
          <a
            style={{ marginTop: 20, fontSize: 13 }}
            id="download-example-file"
            href="https://drive.google.com/file/d/12l6mqXfJEetF9Fbx8VtSJyxEQi1ZrSOK/view?usp=drive_link" target="_blank"
            rel="noopener noreferrer">
            Baixe aqui a planilha modelo de lista de kits.
          </a>
        </div>
      </SimpleForm>

    </Create>)
};

export default KitImport